import { create } from 'zustand'

type ConversationSearchState = {
  clearInputValue: VoidFunction
  setInputValue: (searchValue: string) => void
  searchValue: string
}

export const useConversationSearch = create<ConversationSearchState>(
  set => ({
    clearInputValue: () => set({ searchValue: '' }),
    searchValue: '',
    setInputValue: searchValue => set({ searchValue }),
  }),
)

export const useClearConversationSearch = () =>
  useConversationSearch(state => state.clearInputValue)
